import {
  nullableCreatedByUserUuid,
  timestamps,
  uuid,
} from '@snap-types/models/common';
import { schema } from '@snap-types/schemas';
import { z } from 'zod/v4';

const d = schema.t.dec;

export const columns = {
  uuid,
  sortOrder: z.number().int(),
  netDays: z.number().int(),
  adjustment: schema.t.dec.fromDecimalLike,
  priceSegmentConfigUuid: uuid,

  ...nullableCreatedByUserUuid,
  ...timestamps,

  deletedAt: z.date().nullish(),
};

export const columnValidators = {
  sortOrder: z.number().int().default(0),
  netDays: schema.t.num.fromString.pipe(schema.t.int.positive),
  adjustment: d.fromUnknown.check(d.checks.gte(0)),
};
